/**
 * ActionEditRule の asset 条件・編集値で使う asset id 文字列を扱う。
 * 保存時はそのまま保持し、適用時に crypto/fiat/nft の各 id へ横断的に照合する。
 */

export type ActionEditRuleAssetReference = {
  readonly assetId: string
}

/**
 * asset id 文字列をそのまま扱いやすい構造へ変換する。
 * @param params asset id を受け取る。
 * @returns asset id を保持する構造を返す。
 */
export const parseActionEditRuleAssetReference = ({
  value,
}: {
  readonly value: string
}): ActionEditRuleAssetReference => {
  return {
    assetId: value,
  }
}
